import React from 'react';

import GenericHeading from 'ssg-themes/src/themes/hellofinance/modules/GenericHeading/GenericHeading';
import ContactForm from 'ssg-themes/src/themes/hellofinance/modules/ContactForm/ContactForm';
import Map from 'ssg-themes/src/themes/hellofinance/modules/Map/Map';

import { DATA } from '../data/kontakt.data';

import Seo from "../components/Seo/Seo";
import Base from "../templates/base";


const ContactPage = () => {
  return <Base>
      <Seo {...DATA.seo} />
      <GenericHeading {...DATA.genericHeading} />
      <ContactForm {...DATA.contactForm} />
      <Map {...DATA.map} />
  </Base>;
};

export default ContactPage;
